import React, { Component } from 'react';

import '../../styles/NormalField.css';

class NormalField extends Component {
    render() {
        return (
            <div className="NormalField">
                <label className="NormalField-label">{this.props.label}</label>
                <span className="NormalField-input">{this.props.input}</span>
            </div>
        );
    }
}

export default NormalField;


// WEBPACK FOOTER //
// src/components/innerComponents/NormalField.js